import { defineMessages } from 'react-intl';

export const pasteAddressSectionMessages = defineMessages({
  toggleLabel: {
    defaultMessage: 'Paste US Address',
    id: 'PRt2mD',
    description: 'Toggle button that reveals the paste-address textarea in the Ship To step',
  },
  header: {
    defaultMessage: 'Speed up with copy & paste',
    id: 'EC2o9b',
    description: 'Header for the paste-address section in the freight booking wizard Ship To step',
  },
  description: {
    defaultMessage: 'Paste or type address to fill out the form quickly.',
    id: 'Y33IpT',
    description: 'Description for the paste-address textarea in the freight booking wizard Ship To step',
  },
  label: {
    defaultMessage: 'US Address',
    id: 'tXus6e',
    description: 'Label for the paste-address textarea indicating the expected input format',
  },
  parseError: {
    defaultMessage: 'Unable to parse the provided address',
    id: 'IP7TPX',
    description: 'Inline error shown when the address parse API fails in the Ship To step',
  },
});
